import React, { useState, useRef, useEffect } from "react";
import {
  Modal,
  Form,
  Row,
  Col,
  Select,
  Input,
  DatePicker,
  Button,
  Space,
  message,
} from "antd";
import { HomeOutlined, BarsOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import commonFn from "@/utils/commonFn";
import dayjs from "dayjs";
import { CustomUpload } from "@/hocComponents";

const UtilityPaymentModal = ({
  refreshKeyNewModal,
  open,
  handleSubmit,
  handleCancel,
  form,
  record,
}) => {
  const [vendorOption, setVendorOption] = useState({});
  const [propertyOption, setPropertyOption] = useState({}); //选择Property获取到的数据结构
  const [whichUnitPay, setWhichUnitPay] = useState([]); //选择的unit数据
  const [bankData, setBankData] = useState([]); //选择的bank数据
  const [BtnLoading, setBtnLoading] = useState(false);
  const [propIdList, setPropIdList] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [glAcctValue, setGlAcctValue] = useState('');
  const [glacctList, setGlAcctList] = useState([]);
  const [utilpayType, setUtilpayType] = useState(0);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [filePaths, setFilePaths] = useState([]);
  const [payBy, setPayBy] = useState('');
  const [propData, setPropData] = useState({});

  const afterOpenChangeFn = (flag) => {
    if(flag){
      getRecordFn()
    }else{
      cancelBeforeFn();
    }
  }

  const getRecordFn = async() => {
    const {vendorUtilPaymentId} = record
    if(!vendorUtilPaymentId) return
    setBtnLoading(true);
    const response = await http.post(api.UtilPaymentList, {vendorUtilPaymentId});
    if (response.code === "1") {
      // const data = record || {}
      const data = response?.data || {}
      setPropData(data)
      console.log(record,'===record===NewModal');
      console.log(data,'===data===NewModal');
      setUtilpayType(data.vendorUtilPaymentId || 0);
      const list = [data?.propInfo].map((item) => ({
        ...item,
        value: item?.propId,
        label: item?.propName,
        bankId: item?.apBankId,
      }));

      setPropIdList(list);
      if(!data.vendorUtilPaymentId) return
      const nowmodel = {
        ...data,
        dueDate: data.dueDate && dayjs(data.dueDate) || null,
        // createTime: data.createTime && dayjs(data.createTime) || null,
        // updateTime: data.updateTime && dayjs(data.updateTime) || null,
      };
      form.setFieldsValue(nowmodel);
      unitIdFun(data);
      getvendorFun(data)
      bankFun(data);
      glAcctFun(data);
    }
    setBtnLoading(false);
  }

  const getvendorFun = async(data) => {
    const option = {
      value: data.vendid,
      label: data.vendorId,
      vendorName: data.vendorName,
    }
    setVendorList([option])
    setVendorOption(option);
  }
  //获取propId
  const propIdFun = async (content = '') => {
    const response = await http.get(api.propSearch, { params: { content } });
    if (response.code === "1") {
      const list = (response.data || []).map((item) => ({
        ...item,
        value: item.propId,
        label: item.propName,
        bankId: item.apBankId,
      }));

      setPropIdList(list);
    }
  };

  const vendorSearch = async (content = '') => {;
    const response = await http.get(api.vendorSearch, { params: { content } });
    let  resData = []
    if (response.code === "1") {
      resData = (response.data || []).map((item) => ({
        value: item.vendid,
        label: item.vendorId,
        vendorName: item.vendorName,
      }));
      setVendorList(resData);
    }
    return resData
  };

  //选择propId
  const onTypeChange = (value, option) => {
    setPropertyOption(option);
    form.setFieldsValue({
      bankId: option.bankId,
      remark: option.remark,
      glAcct: ''
    });
    const params = {
      propId: value,
      content: '',
      showId: '',
    }
    unitIdFun(params);
    bankFun(params);
    glAcctFun(params);
  };

  const unitIdFun = async ({propId, content = ''}) => {
    if(!propId){
      setWhichUnitPay([]);
      return
    }
    const response = await http.get(api.unitSearch, { params: {content, propId} });
    const list = (response?.data || [])?.map((item) => ({
      value: item.unitId,
      label: item.unitName,
    }));
    setWhichUnitPay(list);
  };

  const bankFun = async ({propId, content = ''}) => {
    if(!propId){
      setBankData([]);
      return
    }
    const response = await http.get(api.bank, { params: {content, propId} });
    const bankData = (response?.data || [])?.map((item) => ({
      value: item.bankId,
      label: item.name,
    }));
    setBankData(bankData);
  };

  const glAcctFun = async ({propId}) => {
    if(!propId){
      setGlAcctList([]);
      setGlAcctValue('');
      return
    }
    const response = await http.get(api.GetGLList,  { params: {propId} });
    const list = (response || [])?.map((item) => ({
      value: item.glAcct,
      label: item.glAcctName,
      title: item.title,
    }));
    setGlAcctList(list);
    setGlAcctValue(list?.[0]?.value);
  };

  const cancelBeforeFn = () => {
    setBtnLoading(false);
    setUtilpayType(0)
    form.resetFields();
    setPayBy("")
    setGlAcctValue('')
    setVendorList([])
    setWhichUnitPay([])
    setVendorOption({})
    setPropertyOption({})
    setBankData([])
    setGlAcctList([])
  }

  const onCancel = () => {
    handleCancel();
    cancelBeforeFn()
  };

  const vendorChange = async (value, option) => {
    setVendorOption(option);
    form.setFieldsValue({ vendid: value });
  };

  const dueDateChange = (date, dateString) => {
    // Handle date change
  };

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
    // labelAlign: 'left',
  };

  const payBySelectFn = (val) => {
    const payByMatch = {
      'owner': 'Owner is responsible for the bill and does not invoice the Tenant.',
      'tenant': 'Tenant pays bills directly, If Vacant, Owner pays but invoices Tenant if the move-in date is within the service rid. Tenant Pays, Tenants Pays, Tenant Move out then Owner pays, Tenant Move in, Owner pays partial, Tenant Pay Partial, Tenant pays',
      'owner invoice tenant': 'Tenant is responsible for the bill, but Owner pays the bill then invoice Tenant Owner Pays, Owner Pays, Owmers then involce Tenant if Tenant Moves in, Owner Pays invoice tennat, Owner pays involce tenant'
    }
    setPayBy(payByMatch?.[val] || '')
    if(val === 'owner'){
      form.setFieldsValue({
        unitId: undefined,
      });
    }
  }


  //表单form1提交
  const onFinish = async (values) => {
    if(!record?.vendorUtilPaymentId && !filePaths?.length){
      message.error(`Attachment is required!`);
      return
    }
    const params = { 
      ...values,
      vendorId: vendorOption.label,
      dueDateStr: values.dueDate && values.dueDate.format('YYYY-MM-DD') || '',
      prop: propertyOption.prop,
      filePaths: (filePaths || []).filter(item => !item.fileUploadId)
    };
    addEditFun(params)
  };

  //添加方法
  const addEditFun = async (data) => {
    setBtnLoading(true);
    const url = utilpayType ? api.UtilPuymentUpdata : api.UtilPaymentAdd
    const response = await http.post(`${url}`, data);
    if (response.code === "1") {
      message.success(`successfully ${utilpayType ? 'Update' : 'Add'} `);
      form.resetFields();
      onCancel();
      handleSubmit()
      return response;
    }else{
      commonFn.modalFailedFn(response)
      setBtnLoading(false);
    }
  };

  return (
    <Modal
      className="UtilityPayment-NewModal"
      key={refreshKeyNewModal}
      title={
        <div style={{ fontSize: "24px", fontWeight: "bold" }}>
          {`${record?.vendorUtilPaymentId ? 'EDIT' : 'CREATE'}  UTILITY PAYMENT`}
          <div
            style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
          ></div>
        </div>
      }
      centered
      open={open}
      // closable={false}
      maskClosable={false}
      onCancel={onCancel}
      footer={null}
      afterOpenChange={afterOpenChangeFn}
      width="80%"
    >
      <div>
        <Form
          {...layout}
          onFinish={onFinish}
          form={form}
          validateMessages={{
            required: "${label} is required!",
          }}
        >
          <Row gutter={[16, 16]}>
            {/* Payment Information */}
            <Col span={7}>
              <div
                style={{
                  marginBottom: "16px",
                  fontWeight: "bold",
                  fontSize: "20px",
                }}
              >
                <HomeOutlined style={{ marginRight: "8px" }} /> Payment
                Info
              </div>
              <Form.Item
                name="vendid"
                label="Vendor"
                rules={[
                  { required: true },
                  {
                    min: 1,
                    max: 6,
                    message: "The Vendid Must Be Between 1 And 6 Characters.",
                  }
                ]}
              >
                <Select
                  showSearch
                  placeholder="Select a type"
                  onChange={vendorChange}
                  onSearch={vendorSearch}
                  optionLabelProp="value"
                  value={vendorOption?.value}
                  filterOption={(input, option) =>
                    (option?.vendorName ?? "")?.toLowerCase().includes(input.toLowerCase())
                  }
                  fieldNames={{ label: "vendorName" }}
                  options={vendorList}
                />
                <div>{vendorOption?.vendorName || ''}</div>
              </Form.Item>

              <Form.Item name="vendorUtilPaymentId" hidden>
                <Input type="hidden" />
              </Form.Item>

              <Form.Item
                name="propId"
                label="Property"
                rules={[{ required: true }]}
              >
                <Select
                  showSearch
                  placeholder="Select a type"
                  onChange={onTypeChange}
                  onSearch={propIdFun}
                  optionFilterProp="label"
                  value={propertyOption?.propId}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={propIdList}
                />
              </Form.Item>

              <Form.Item
                name="bankId"
                label="Account Payable Bank"
                rules={[{ required: true }]}
              >
                <Select
                  showSearch
                  placeholder="Select a type"
                  optionLabelProp="label"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={bankData}
                />
              </Form.Item>

              <Form.Item
                name="glAcct"
                label="Expense GL Account"
                rules={[{ required: true }]}
              >
                <Select
                  showSearch
                  placeholder="Select a type"
                  optionFilterProp="label"
                  value={propertyOption?.propId}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={glacctList}
                />
              </Form.Item>

              <Form.Item
                name="remark"
                label="Check Memo"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>

              {/* <Form.Item name="createByName" label="Create By">
                <Input disabled />
              </Form.Item>
  
              <Form.Item name="createTime" label="Create Time">
                <DatePicker
                  disabled
                  style={{ width: "100%" }}
                  format="MM/DD/YYYY"
                />
              </Form.Item>

              <Form.Item name="updateByName" label="Last Update By">
                <Input disabled />
              </Form.Item>
  
              <Form.Item name="updateTime" label="Last Update Time">
                <DatePicker
                  disabled
                  style={{ width: "100%" }}
                  format="MM/DD/YYYY"
                />
              </Form.Item> */}

            </Col>

            <Col span={7}>
            {/* Account & Meter Information */}
              <div
                style={{
                  marginBottom: "16px",
                  fontWeight: "bold",
                  fontSize: "20px",
                }}
              >
                <HomeOutlined style={{ marginRight: "8px" }} /> Account & Meter
                Information
              </div>

              <Form.Item
                name="customerAccount"
                label="Account #"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                name="dueDate"
                label="Due Date"
                rules={[{ required: true }]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  format={['MM/DD/YYYY', "M/D/YYYY"]}
                  onChange={dueDateChange}
                />
              </Form.Item>

              <Form.Item
                name="payFreq"
                label="Payment Frequency"
                rules={[{ required: true }]}
              >
                <Select
                  showSearch
                  placeholder="Select a type"
                  optionFilterProp="label"
                  value={propertyOption?.propId}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={[
                    { value: "1", label: "Monthly" },
                    { value: "2", label: "Every 2 Months" },
                    { value: "3", label: "Quarterly" },
                    { value: "12", label: "Annually" },
                  ]}
                />
              </Form.Item>

              <Form.Item
                name="serviceAddress"
                label="Service Address"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                name="payBy"
                label="Pay By Who"
                rules={[{ required: true }]}
              >
                <Select
                  onSelect={payBySelectFn}
                  showSearch
                  placeholder="Select a type"
                  optionFilterProp="label"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={[
                    { value: "owner", label: "Owner" },
                    { value: "tenant", label: "Tenant" },
                    {
                      value: "owner invoice tenant",
                      label: "Owner Invoice Tenant",
                    },
                  ]}
                />
              </Form.Item>
              {payBy && <Form.Item
                name="temp"
                label={null}
              >
                <div
                  style={{
                    fontSize: "14px",
                  }}
                >
                  { payBy }
                </div>
              </Form.Item>}
              <Form.Item
                name="unitId"
                label="Which Unit Pay"
                rules={[{ required: false }]}
              >
                <Select
                  showSearch
                  placeholder="Select a unitId"
                  optionFilterProp="label"
                  value={propertyOption?.propId}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={whichUnitPay}
                />
              </Form.Item>

              {
                [
                  {
                    name: "gasMeter",
                    label: "Gas Meter#",
                  },
                  {
                    name: "gasRemark",
                    label: "Gas Remark",
                  },
                  {
                    name: "waterMeter",
                    label: "Water Meter#",
                  },
                  {
                    name: "waterMeterSize",
                    label: "Water Meter Size",
                  },
                  {
                    name: "waterRemark",
                    label: "Water Remark",
                  },
                  {
                    name: "electricMeter",
                    label: "Electric Meter",
                  },
                  {
                    name: "electricRemark",
                    label: "Electric Remark",
                  },
                  {
                    name: "sewerRemark",
                    label: "Sewer Remark",
                  },
                  {
                    name: "loginWebsite",
                    label: "Login Website",
                  },
                  {
                    name: "loginUserName",
                    label: "Login User Name",
                  },
                  {
                    name: "loginPassWord",
                    label: "Login Password",
                  },
                  {
                    name: "webitWithoutLockIn",
                    label: "Webit Without Lock In",
                  }
                ].map(item=>{
                  return (
                    <Form.Item
                      name={item.name}
                      label={item.label}
                      rules={[{ required: item?.required }]}
                    >
                      <Input />
                    </Form.Item>
                  );
                })
              }
            </Col>

            <Col span={10}>
              <div
                 style={{
                   marginBottom: "16px",
                   fontWeight: "bold",
                   fontSize: "20px",
                 }}
               >
                <>
                  <span style={{
                    display: 'inline-block',
                    marginInlineEnd: '4px',
                    color: '#ff4d4f',
                    fontSize: '14px',
                    fontFamily: 'SimSun, sans-serif',
                    lineHeight: 1,
                    boxSizing: 'border-box',
                    whiteSpace: 'initial',
                    textAlign: 'start',
                  }}>
                   *
                  </span>
                  Upload PDF image
                </>
               </div>
               <Form.Item labelCol={{ span: 0 }} wrapperCol={{ span: 24 }} name="filePaths" label={null}>
                 <CustomUpload 
                    setFilePaths={setFilePaths} 
                    filePaths={filePaths} 
                    setBtnDisabled={setBtnDisabled}
                    btnDisabled={btnDisabled}
                    isEdit={record?.vendorUtilPaymentId}
                    foreignId={record?.vendorUtilPaymentId || undefined}
                    type={'util_payment_add'}
                    customConfig={{
                      accept: ".jpg, .jpeg, .png, .pdf",
                      pdfHeight: '60vh',
                      pageName: 'NewModal',
                      noShowUpload: record?.vendorUtilPaymentId
                    }}
                  />
               </Form.Item>

            </Col>
          </Row>

          <Form.Item className="btnCenter">
            <Space align="center">
              <Button key="back" onClick={onCancel}>
                Cancel
              </Button>
              <Button type="primary" htmlType="submit" loading={BtnLoading} disabled={btnDisabled}>
                Submit
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

export default UtilityPaymentModal;
